import { Avatar } from '@mui/material';
import { EducationFallback as Education } from '../../../icons/education-fallback';

type EducationFallbackProps = {
    width: string,
    height: string,
}

export const EducationFallback = ({ width, height }:EducationFallbackProps): JSX.Element => {
  return (
    <Avatar
      alt="aleternate"
      sx={ {
        width,
        height,
        bgcolor: 'rgba(48, 37, 133, 1)',
      } }
      src=""
    >
      <Education />
    </Avatar>
  );
};
